// @ts-nocheck
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { ProductModel, VariantTraitModel } from "@insite/client-framework/Types/ApiModels";
import cloneDeep from "lodash/cloneDeep";

export default (
    inventory: { [key: string]: number },
    variantTraits: VariantTraitModel[],
    variantChildren: ProductModel[],
    variantSelection: SafeDictionary<string>,
) => {
    const filteredVariantTraitsOutOfStock = cloneDeep(variantTraits?.slice());
    const childTraitValueLists = variantChildren?.map(product => {
        return { childTraitValues: product.childTraitValues, id: product.id };
    });

    const outOfStockProductIds: string[] = [];

    filteredVariantTraitsOutOfStock.forEach(variantTrait => {
        variantTrait.traitValues?.forEach(traitValue => {
            if (traitValue.id !== variantSelection[variantTrait.id]) {
                return;
            }

            const productWithSelectedTrait = childTraitValueLists.filter(product =>
                product.childTraitValues?.some(trait => trait.id === traitValue.id),
            );

            productWithSelectedTrait.forEach(product => {
                if (inventory[product.id] <= 0) {
                    const outOfStockProduct = product.childTraitValues?.filter(t => t.id !== traitValue.id) || [];

                    outOfStockProduct.forEach(product => {
                        outOfStockProductIds.push(product.id);
                    });
                }
            });
        });
    });

    filteredVariantTraitsOutOfStock.forEach(variantTrait => {
        variantTrait.traitValues?.forEach(traitValue => {
            if (outOfStockProductIds.indexOf(traitValue.id) > -1) {
                traitValue.isDisabled = true;
            }
        });
    });

    return filteredVariantTraitsOutOfStock.sort((a, b) => a.sortOrder - b.sortOrder);
};
